import { render, staticRenderFns } from "./StockCard.vue?vue&type=template&id=a00fbc1e&scoped=true"
import script from "./StockCard.vue?vue&type=script&lang=js"
export * from "./StockCard.vue?vue&type=script&lang=js"
import style0 from "./StockCard.vue?vue&type=style&index=0&id=a00fbc1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00fbc1e",
  null
  
)

export default component.exports